import { Lock } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@roger/ui-components';
import type { TaskStatus } from '../../services/api/types.gen';
import { getLockedTaskTooltip, type LockedTaskType } from './lockedTask';

interface LockedTaskIndicatorProps {
  taskType: LockedTaskType;
  status: TaskStatus | null | undefined;
}

export function LockedTaskIndicator({
  taskType,
  status,
}: LockedTaskIndicatorProps) {
  const tooltip = getLockedTaskTooltip(taskType, status);

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type='button'
            aria-label={tooltip}
            className='inline-flex h-5 w-5 shrink-0 items-center justify-center rounded text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1'
          >
            <Lock
              aria-hidden='true'
              className='h-3.5 w-3.5'
              data-testid='locked-task-icon'
            />
          </button>
        </TooltipTrigger>
        <TooltipContent className='max-w-xs text-xs' side='top'>
          {tooltip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
